export const constants = {
  MFE_FACTORY_GPT_NAME: 'factoryGpt',
  MFE_EXPOSED_PATH: './FactoryGptApp',
  MFE_MOBILE_EXPOSED_PATH: './FactoryGptMobile',
  WIDGET_EXPOSED_PATH: './FactoryGptWidget',
  MFE_CUSTOM_AGENT_NAME: 'customAgent',
  CUSTOM_AGENT_EXPOSED_PATH: './CustomAgent',
};
